import { useEffect, useState } from 'react';

import { AssetLoaderService, AssetLoaderServiceState } from '../AssetLoaderService';
import type { ResourceMap } from '../AssetLoaderService';

export const useAssetLoaderService = (gameResources: ResourceMap | undefined): boolean => {
  const ready = useAssetLoaderServiceReady();

  useEffect(() => {
    if (gameResources) AssetLoaderService.init(gameResources);
  }, [gameResources]);

  return ready;
};

const useAssetLoaderServiceReady = (): boolean => {
  const [ready, setReady] = useState<boolean>(AssetLoaderService.state === AssetLoaderServiceState.UNBLOCKED);

  useEffect(() => {
    return AssetLoaderService.addEventListener('ready', () => setReady(true));
  }, []);

  return ready;
};
